import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { filter, map, Observable } from 'rxjs';

import { AuthFacade } from '~console/app/~store/facades/auth.facade';
import { ROUTES } from '../constants/routes.constants';
import { UserRole } from '~core/models/auth.models';
import { isValidMigration } from '~core/utils/utils';
import { DialogService } from '~console/app/~shared/services/dialog.service';
import { Organization } from '~core/models/organization.models';
import { CompanyUserMigrationModalComponent } from '~console/app/auth/modals/company-user-migration-modal/company-user-migration-modal.component';

export const ONBOARDING_COMPLETED_GUARD = (
  _route: ActivatedRouteSnapshot,
  _next: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
  void _route;
  void _next;
  const authFacade = inject(AuthFacade);
  const router = inject(Router);
  const dialogService = inject(DialogService);

  return authFacade.currentUser$.pipe(
    filter(Boolean),
    map(currentUser => {
      const isPrivilegedUser =
        currentUser.roles.includes(UserRole.ROLE_SUPER_ADMIN) ||
        currentUser.roles.includes(UserRole.ROLE_ADMIN);

      if (
        (currentUser.organization as Organization | undefined)
          ?.onboardingCompleted ||
        isPrivilegedUser
      ) {
        return true;
      }

      if (isValidMigration(currentUser.organization?.metadata)) {
        const isManager =
          currentUser.organization.manager?.id === currentUser.id;

        if (isManager) {
          return router.createUrlTree([ROUTES.migrationOnboarding]);
        }

        const isAlreadyOpen = dialogService.dialog.openDialogs.some(
          dialog =>
            dialog.componentInstance instanceof
            CompanyUserMigrationModalComponent
        );
        if (!isAlreadyOpen) {
          dialogService.open({
            component: CompanyUserMigrationModalComponent,
            config: {
              panelClass: ['mat-dialog-custom'],
              disableClose: true,
              autoFocus: false,
              maxWidth: '820px'
            }
          });
        }
        return true;
      }

      return router.createUrlTree([ROUTES.onboarding]);
    })
  );
};
